import { GenericCategoryRoute } from 'src/generics/data';

import { CategoryInfo } from 'shop/types';
import { genericCategoryRouteInfo } from 'shop/constants/categories';

export function getGenericCategoryRouteInfo(category: GenericCategoryRoute): CategoryInfo {
  return genericCategoryRouteInfo[category];
}
